import PdaTitle from '../../component/common/PdaTitle'
import React, { useCallback, useContext, useState } from 'react'
import { classNames } from 'primereact/utils'
import { useMountEffect } from 'primereact/hooks'
import { useNavigate } from 'react-router-dom'
import { CommonContext } from '../../component/common/context/commonContext'
import { InventorySurveyInfo } from '../../types/inventory'
import { includeComma, markDayHyphen } from '../../utils/inputText'
import { useTranslation } from 'react-i18next'
import { tokens } from 'locales/tokens'

const InventorySurvey = () => {
    const { $http } = useContext(CommonContext)
    const { t } = useTranslation()
    const [inventorySurveyInfo, setInventorySurveyInfo] = useState<InventorySurveyInfo>()
    const [percent, setPercent] = useState<number>(0)

    const find = useCallback(async () => {
        await $http()
            .get('/inventory-survey')
            .then((res: InventorySurveyInfo) => {
                setInventorySurveyInfo(res)
                setPercent(Math.round((Number(res?.completeCnt) / Number(res?.ttlLctCnt)) * 100))
            })
    }, [$http])

    useMountEffect(() => {
        makeHeight()
        find()
    })

    const navigate = useNavigate()
    const [height, setHeight] = useState<number>(0)
    const makeHeight = () => {
        const title = document.getElementsByClassName('pda-title')[0]

        setHeight(window.innerHeight - title.getBoundingClientRect().height)
    }

    const onClickSurveyInfo = () => {
        navigate('/inventory-survey-info', {
            state: {
                inventorySurveyInfo: inventorySurveyInfo,
                percent: percent,
            },
        })
    }

    return (
        <div>
            <PdaTitle title={t(tokens.common.inventory_investigation)} historyBack goToHome />
            <div className="mt-1 overflow-y-scroll p-3 pt-1" style={{ height }}>
                {inventorySurveyInfo?.lctSeqs ? (
                    <div
                        className="w-full p-1 mb-1 border-1 border-round-2xl bg-white"
                        style={{ borderColor: '#D3D3D3' }}
                        onClick={onClickSurveyInfo}
                    >
                        <div className="col-12 flex py-0 font-bold">
                            <div className={classNames('col-5 text-left')}>재고조사 대기중</div>
                            <div className="col-7 align-self-center text-left text-right">
                                {includeComma(inventorySurveyInfo?.completeCnt, '-')} / {includeComma(inventorySurveyInfo?.ttlLctCnt, '-')} (
                                {percent === 100 ? (
                                    <span className="rdms-text-success font-bold">{percent}%</span>
                                ) : (
                                    <span className="rdms-text-danger font-bold">{percent}%</span>
                                )}
                                )
                            </div>
                        </div>
                        <div className="col-12 justify-content-between flex py-0 font-bold align-items-center">
                            <div className={classNames('col-4 text-left rdms-text-primary')}>재고조사일</div>
                            <div className="col-8 text-left text-overflow-ellipsis overflow-hidden white-space-nowrap">
                                {markDayHyphen(inventorySurveyInfo?.srvyStartYmd)}
                            </div>
                        </div>
                        <div className="col-12 justify-content-between flex py-0 font-bold align-items-center">
                            <div className={classNames('col-4 text-left rdms-text-primary pt-0')}>총 조사항목 수</div>
                            <div className="col-8 text-left text-overflow-ellipsis overflow-hidden white-space-nowrap pt-0">
                                총 {includeComma(inventorySurveyInfo?.ttlLctCnt, '-')} 개 ({includeComma(inventorySurveyInfo?.skuCnt, '-')} SKU)
                            </div>
                        </div>
                    </div>
                ) : null}
            </div>
        </div>
    )
}

export default InventorySurvey
